import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  WfMdActionService,
  WfMdActionContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';

@Component({
  selector: 'app-workflow-action',
  templateUrl: './workflow-action.component.html',
  styleUrls: ['./workflow-action.component.css']
})
export class WorkflowActionComponent implements OnInit, OnDestroy {

  @Input() action: FormControl;
  @Output() actionChange = new EventEmitter<FormControl>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<WfMdActionContainerModel[]> = new ReplaySubject<WfMdActionContainerModel[]>(1);
  actionList: WfMdActionContainerModel[];

  constructor( private actionService: WfMdActionService ) {}

  ngOnInit() {
    this.subs.sink = this.actionService.get(this.apiVisa).subscribe(
      {next: resolve => {
        this.actionList = resolve.data;
        this.filteredOptions$.next(this.actionList);
      }});
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterApplet(resolve)});
  }

  filterApplet(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.actionList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.actionList.filter(c => c.bl_wf_md_action.namespace.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
